/** 通用 */
global.company = "杭州格物智安科技有限公司";
global.logo = require("@/assets/img/logo.jpg");
// 导航栏数据项列表
global.routerList = [
  { router: "/", title: "首页" },
  { router: "/technology", title: "核心技术" },
  { router: "/product", title: "产品中心" },
  { router: "/application", title: "应用场景" },
  { router: "/news", title: "新闻资讯" },
  { router: "/aboutUs", title: "关于我们" },
  { router: "/documentation", title: "帮助中心" },
];

global.download = {
  logo: require("@/assets/img/download/gwzaapp.png"),
  logoFxh: require("@/assets/img/download/fxh.png"),
  androidLogo: require("@/assets/img/download/android.png"),
  iosLogo: require("@/assets/img/download/ios.png"),
};

// 底部栏数据项
global.footerObj = {
  picture: require("@/assets/img/footer/footerBackground.jpg"),
  // 联系我们
  contact: [
    "公司地址：杭州市西湖区文三路199号13幢405室",
    "联系电话：15618049835",
    "联系邮箱：gwzacompany@126.com",
    "联系邮箱：gwzacompany@163.com",
  ],
  // 关注我们
  attention: [
    { picture: require("@/assets/img/footer/account.jpg"), title: "公众号" },
    { picture: require("@/assets/img/footer/app.png"), title: "app 下载" },
    { picture: require("@/assets/img/footer/applet.jpg"), title: "小程序" },
  ],
  // 版权文字
  copyright: "Copyright©2020-2024 GWZA 杭州格物智安科技有限公司 版权所有",
  record: "浙ICP备18040014号-3",
  recordUrl: "https://beian.miit.gov.cn",
};

// 轮播图数据项列表
global.rotationPlotList = [
  // {
  //   title: '格物智安欢迎您的到来',
  //   // mp4: require('@/assets/img/rotationPlot/rotationPlot_0.mp4')
  //   // picture: require('@/assets/img/rotationPlot/rotationPlot_0.gif')
  //   mp4: 'https://gwza2023.obs.myhuaweicloud.com/screenBgPhotos/rotationPlot_0.mp4'
  //   // picture: 'https://gwza2023.obs.myhuaweicloud.com/screenBgPhotos/rotationPlot_0.gif'
  // },
  {
    title: "高速智能引擎",
    picture: require("@/assets/img/rotationPlot/rotationPlot_2.jpg"),
  },
  {
    title: "复杂环境下的厘米级定位",
    title2: "与鲁棒通信专家",
    picture: require("@/assets/img/rotationPlot/rotationPlot_1.jpg"),
  },
  {
    title: "高精度、全覆盖",
    title2: "室内室外一体化融合定位系统",
    // picture: require('@/assets/img/rotationPlot/rotationPlot_3.gif')
    // picture: 'https://gwza2023.obs.myhuaweicloud.com/screenBgPhotos/rotationPlot_3.gif'
    mp4: "https://gwza2023.obs.myhuaweicloud.com/screenBgPhotos/rotationPlot_3.mp4",
    // mp4: require('@/assets/img/rotationPlot/rotationPlot_3.mp4')
  },
  {
    title: "集多模定位与多模通信",
    title2: "于一体的全栈式定位通信系统",
    picture: require("@/assets/img/rotationPlot/rotationPlot_4.jpg"),
  },
];

/** 首页 */
global.mainObj = {
  // 技术数据项列表
  technologyTitle: "专业物联网设备与技术服务提供商",
  technologyList: [
    {
      title: "精准定位",
      picture: require("@/assets/img/mainPage/projectService_1.jpg"),
    },
    {
      title: "智能安全帽",
      picture: require("@/assets/img/mainPage/projectService_2.jpg"),
    },
    {
      title: "智能系统",
      picture: require("@/assets/img/mainPage/projectService_3.jpg"),
    },
    {
      title: "智芯焊",
      picture: require("@/assets/img/mainPage/projectService_4.jpg"),
    },
  ],
  // 行业解决方案列表
  solutionList: [
    {
      isHover: false,
      title: "电厂电力",
      picture: require("@/assets/img/mainPage/project_1.jpg"),
      detailPicture: require("@/assets/img/mainPage/projectDetail_1.jpg"),
      content:
        "智慧电厂高精度定位系统，主要由定位终端、定位通信基站、定位通信网关和中央服务器组成，同时采用多模通信，进行定位终端和通信网关之间的双向通信，不仅可以及时传输关键定位信息和传感信息等数据，还可以传输视频和图片等大的数据。通过在厂区内布设合理数量的基站，实现高精度的目标定位和追踪，并结合电子围栏、轨迹回放、动态预警、视频监控等功能，实现对电厂区域作业管理、高风险作业监控、巡检过程管理等环节的智能精确管控。助力电厂实现运营全流程的一体化联动，极大地提高电厂系统整体的可视化能力、协调能力、决策支持能力和安全防范能力。",
    },
    {
      isHover: false,
      title: "智慧工地",
      picture: require("@/assets/img/mainPage/project_2.jpg"),
      detailPicture: require("@/assets/img/mainPage/projectDetail_2.jpg"),
      content:
        "智慧工地高精度人员定位系统，采用UWB定位技术，通过在施工工地部署一定数量的定位基站，为人员佩戴安全帽的形式，实时获取精确位置信息。工地人员定位系统支持实时定位、轨迹回放、电子点名和时长统计等功能，提高工地现场管理效率，维持现场秩序，全方位助力工地智能化监管，实现多场景精确定位、运营调度全局掌控。同时提供电子围栏功能，人员进入危险区域即刻告警；当危险情况发生时，系统可按区域对施工人员下发撤离命令，施工人员也可通过安全帽一键SOS按键自主报警，安全救援实时保障；可进行多种人员行为监测，有效预防安全事故发生，为整个工地的安全施工保驾护航。",
    },
    {
      isHover: false,
      title: "化工企业",
      picture: require("@/assets/img/mainPage/project_3.jpg"),
      detailPicture: require("@/assets/img/mainPage/projectDetail_3.jpg"),
      content:
        "化工企业高精度人员定位系统，采用UWB定位技术，通过在生产区域部署一定数量的定位基站，为人员佩戴安全帽的形式，实时获取精确位置信息。在基站布置覆盖范围厂区发生危险等意外时，佩戴人员可通过标签SOS执行一键呼叫，提高员工工作安全性。通过人员定位系统进行厂内多区域人员、车辆实时监控，通过厂区360度无死角可视化管理，进行人员、车辆等有效调度，提高厂区整体管理水平。此外，人员定位系统还支持轨迹回放功能，对违反装置安全作业或违反巡检路线导致的损失/事故可回溯追查，借助于历史轨迹和视频联动精准的复原事故违规作业的全过程，提高化工企业生产安全和效率。",
    },
    {
      isHover: false,
      title: "智慧消防",
      picture: require("@/assets/img/mainPage/project_4.jpg"),
      detailPicture: require("@/assets/img/mainPage/projectDetail_4.jpg"),
      content:
        "智慧消防高精度定位系统，通过在消防设施和消防安全帽安装UWB标签，可以实时监测设施的运行状态和人员位置及行动轨迹，实现对火源的快速定位。同时，可以实现高速数据传输，将现场图像和数据实时传输到指挥中心，帮助指挥人员做出更准确的决策，提高救援效率。此外，智慧消防人员定位系统还可以与其它系统进行集成，如视频监控系统、火灾报警系统等，实现更全面的消防安全监控和管理。",
    },
  ],
};

/** 核心技术 */
global.technology = {
  title: "创新式定位通信",
  titlePicture: require("@/assets/img/technology/technology_ban.jpg"),
  titlePicture1: require("@/assets/img/technology/technology_1.jpg"),
  titlePicture2: require("@/assets/img/technology/technology_2.jpg"),
  titlePicture3: require("@/assets/img/technology/technology_3.jpg"),
  titleContent:
    "采用多模定位和多模通信的融合架构，解决复杂环境下的精准定位和鲁棒通信，结合各种传感器实现在复杂环境下对现场人员进行全程、精准、实时、无死角、多角度、可视化、立体式监控的目标，能够随时掌握现场人员的具体位置及具体安全情况。",
  mainTitle: "安全生产全方位，格物智安来助力",
  // 核心技术
  technologyList: [
    {
      title: "UWB精准定位技术",
      content: "双向通信",
      picture: require("@/assets/img/technology/coreTechnology_1.jpg"),
    },
    {
      title: "自适应算法",
      content: "刷新率与精度兼顾",
      picture: require("@/assets/img/technology/coreTechnology_2.jpg"),
    },
    {
      title: "鲁棒通信",
      content: "抗复杂环境",
      picture: require("@/assets/img/technology/coreTechnology_3.jpg"),
    },
    {
      title: "高精度算法",
      content: "多模定位",
      picture: require("@/assets/img/technology/coreTechnology_4.jpg"),
    },
    {
      title: "多路复用技术",
      content: "高并发、低时延",
      picture: require("@/assets/img/technology/coreTechnology_5.jpg"),
    },
    {
      title: "使能算法",
      content: "低功耗、低辐射",
      picture: require("@/assets/img/technology/coreTechnology_6.jpg"),
    },
  ],
  posTitle: "定位对比",
  posBackground: require("@/assets/img/technology/posBackground.jpg"),
  posPicture: require("@/assets/img/technology/posPicture.jpg"),
};

/** 产品中心 */
global.product = {
  title: "科技化的产品细节展示",
  titlePicture: require("@/assets/img/product/product.jpg"),
  productList: [
    {
      id: "1",
      title: "UWB定位",
      content: [
        "创新式UWB定位通信系统，采用多模定位和多模通信的融合架构，解决复杂环境下的精准定位和鲁棒通信，实现10cm级定位精度。同时结合各种传感器实现在复杂环境下对现场人员进行全程、精准、实时、无死角、多角度、可视化、立体式的监控的目标，能够随时掌握现场人员的具体位置及具体安全情况。",
        "实现路径：通过合理部署定位通信基站、定位通信网关、定位终端和服务器等系统设备，实现高精度的目标定位和追踪。同时借助定位应用软件，在精确定位基础上，实现轨迹回放、智能预警、视频联动、大数据分析等多种应用功能。",
      ],
    },
    {
      id: "2",
      title: "系统架构",
      picture: require("@/assets/img/product/product_architecture.jpg"),
    },
    {
      id: "3",
      title: "智能安全帽",
      content: [
        "智能安全帽集身份认证、人员定位、跌倒监测、电量监测、呻吟报警、安全帽佩戴检测、心率、体温、呼吸监测、实时摄像头及无线传输等多功能于一体，全面实时识别风险并主动提醒佩戴者和管理人员。",
      ],
      picture: require("@/assets/img/product/product_helmet.jpg"),
    },
    {
      id: "4",
      title: "高精度定位设备",
      productDetailList: [
        {
          id: "4-1",
          title: "UWB定位通信基站",
          detailList: [
            {
              title: "定位基站",
              picture: require("@/assets/img/product/product_anchorIn.png"),
              content: [
                { label: "供电电压", value: "220V（AC）" },
                { label: "工作电压", value: "5V（DC）" },
                { label: "待机电流", value: "35uA" },
                { label: "工作温度", value: "-10 ~ 60℃" },
                { label: "信号覆盖", value: "500m（可视距离）" },
                { label: "安全机制", value: "短路保护" },
              ],
            },
            {
              title: "太阳能基站",
              picture: require("@/assets/img/product/product_anchorOut.png"),
              content: [
                { label: "供电方式", value: "太阳能供电" },
                { label: "工作电压", value: "5V（DC）" },
                { label: "待机电流", value: "35uA" },
                { label: "工作温度", value: "-10 ~ 60℃" },
                { label: "信号覆盖", value: "500m（可视距离）" },
                { label: "安全机制", value: "短路保护" },
              ],
            },
          ],
        },
        {
          id: "4-2",
          title: "UWB定位通信网关",
          detailList: [
            {
              picture: require("@/assets/img/product/product_lora.jpg"),
              content: [
                { label: "供电电压", value: "220V（AC）" },
                { label: "待机电流", value: "35uA" },
                { label: "工作温度", value: "-10 ~ 60℃" },
                { label: "通信距离", value: "≥1km（可视距离）" },
                { label: "内存配置", value: "≥8GB" },
                { label: "网络接口", value: "支持有线、无线" },
              ],
            },
          ],
        },
        {
          id: "4-3",
          title: "UWB定位终端",
          detailList: [
            {
              title: "工牌型",
              picture: require("@/assets/img/product/product_tagCard.jpg"),
              content: [
                { label: "电池种类", value: "可充电锂电池" },
                { label: "工作时间", value: "1 ~ 3 天一充" },
                { label: "工作温度", value: "-20 ~ 70℃" },
                { label: "储存温度", value: "-40 ~ 85℃" },
                { label: "工作湿度", value: "10% ~ 90%无结霜" },
              ],
            },
            {
              title: "腕带型",
              picture: require("@/assets/img/product/product_tagWatch.jpg"),
              content: [
                { label: "电池种类", value: "可充电锂电池" },
                { label: "工作时间", value: "1 ~ 3 天一充" },
                { label: "工作温度", value: "-20 ~ 70℃" },
                { label: "储存温度", value: "-40 ~ 85℃" },
                { label: "工作湿度", value: "10% ~ 90%无结霜" },
                { label: "防水等级", value: "IP67" },
              ],
            },
            {
              title: "智能安全帽",
              picture: require("@/assets/img/product/product_tagHelmet.jpg"),
              content: [
                { label: "电池种类", value: "可充电锂电池" },
                { label: "充电口", value: "Type-C" },
                { label: "待机电流", value: "35uA" },
                { label: "工作时间", value: "6-7天（每天8小时）" },
                { label: "工作温度", value: "-10 ~ 60℃" },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "5",
      title: "基础定位系统",
      productDetailList: [
        {
          id: "5-1",
          title: "电子地图",
          picture: require("@/assets/img/product/product_map.jpg"),
          content: [
            "支持多场景地图展示。",
            "支持二维、三维地图一键切换，以及室内外地图一体化展示。",
            "支持地图各项基础操作显示，包括移动、放大、缩小、旋转（仅三维模式下）等操作，且存在地图复位功能，可一键恢复至地图初始显示位置及视角。",
          ],
        },
        {
          id: "5-2",
          title: "实时状态",
          picture: require("@/assets/img/product/product_live.jpg"),
          content: [
            "实时展示各类定位设备的所处位置，包括定位终端（显示为人员模型）、定位通信网关、定位通信基站的所处位置，可通过二维、三维模式的切换进行查看。",
            "支持各类违规检测，及时告警违规人员，并通知管理人员。",
            "支持人员体温、心率、呼吸等健康数据检测以及数据查看。",
          ],
        },
        {
          id: "5-3",
          title: "电子围栏",
          picture: require("@/assets/img/product/product_rules.jpg"),
          content: [
            "基于三维电子地图，可通过多种方式（地图画点、数值画点、走动画点）添加电子围栏，根据具体情况规划、绘制、确定危险区域或安全区域。",
            "高精度电子围栏，当佩戴定位终端的人员靠近或进入危险区域时，定位终端会通过喇叭报警，实时提醒作业人员，提高了对危险区域的安全管控能力。",
          ],
        },
        {
          id: "5-4",
          title: "轨迹回放",
          picture: require("@/assets/img/product/product_review.jpg"),
          content: [
            "基于定位，以时间为维度进行可视化，展示指定目标在地图移动的轨迹，以动画的形式回放指定目标在实际路线的轨迹。",
            "可查看任意人员任意时间段内的运动轨迹，追溯人员作业历史过程。",
            "轨迹回放过程中，可以切换二维、三维视图进行多维度查看。",
            "路径优化，使轨迹更加丝滑流畅。",
          ],
        },
        {
          id: "5-5",
          title: "智能预警",
          picture: require("@/assets/img/product/product_anomaly.jpg"),
          content: [
            "支持电子围栏靠近、违规告警，可以回放违规时间段内轨迹，可查看违规位置。",
            "支持长时间静止不动告警，可以自行配置静止不动的时间判断阈值，可查看异常位置。",
            "支持受到撞击异常告警，可查看发生撞击时所在位置。",
            "支持一键SOS告警，及时发出求救告警信息。",
          ],
        },
        {
          id: "5-6",
          title: "电子点名",
          picture: require("@/assets/img/product/product_meetingRollCall.jpg"),
          content: [
            "支持晨会、安全教育、现场出勤等多种形式电子点名来确认人员在场情况。",
            "支持距离点名、地图画点等多种点名方式。",
            "支持电子点名积分制，鼓励人员按需、按时参与电子点名，便于人员管理。",
          ],
        },
        {
          id: "5-7",
          title: "大屏展示",
          picture: require("@/assets/img/product/product_screen.jpg"),
          content: [
            "通过视频监控实现现场的可视化管理，进行全方位覆盖管控，保障人员作业安全以及作业规范。",
            "大屏支持自定义，选择已有板块进行大屏设计，可随意对组件位置进行拖动、伸缩。",
          ],
        },
        {
          id: "5-8",
          title: "时长统计",
          picture: require("@/assets/img/product/product_statisticalTime.jpg"),
          content: [
            "统计佩戴定位终端设备的人员每日在线、离线时长，并可按照周/月/年总时长的形式进行展示。",
            "支持人员工作时间、休息的时间段设置。",
            "以统计图的形式进行展示，可以直观地看出人员每日实际工作状态，便于人员工作时间的统计。",
          ],
        },
        {
          id: "5-9",
          title: "在线巡更管理",
          picture: require("@/assets/img/product/product_patrol.jpg"),
          content: [
            "现场巡更，图文及时上传，实现“定时、定点、定人”的要求，双重保障，防止作弊。全面记录巡更情况，实时进行数据分析。",
            "智能检测巡更人员是否到达巡更指定位置。",
            "巡更记录支持导出，便于查看分析。",
          ],
        },
        {
          id: "5-10",
          title: "安全问题上报",
          picture: require("@/assets/img/product/product_safety.jpg"),
          content: [
            "任何人员发现作业场所存在安全问题，都可以及时上报填写，打造更安全的作业环境，人人有责。",
            "整改意见实时传递，现场问题及时处理，提高现场应急处置能力。",
          ],
        },
      ],
    },
    {
      id: "6",
      title: "智芯焊",
      productDetailList: [
        {
          id: "6-1",
          // title: '电焊',
          picture: require("@/assets/img/product/product_dianhanIntro.jpg"),
          content: [
            "智芯焊的设计理念在于提升作业安全性和效率。用户必须通过实名认证并上传相应的资质证书，经审核通过后方可操作电焊机。这一流程确保了操作人员的专业资质，保障了作业现场的安全合规，有效降低了安全风险。",
            "软件配备了先进的实时监控系统，能够即时捕捉并分析工程进度中的关键数据和设备状态。这一功能不仅帮助用户全面掌握作业情况，还能在潜在故障发生前发出预警，从而预防事故的发生。",
          ],
        },
        {
          id: "6-2",
          // title: '电焊机安全监控管理',
          picture: require("@/assets/img/product/product_dianhan.jpg"),
          content: [
            "系统通过物联网感知设备对每台电焊机进⾏实名制登记，确保各项作业条件安全可靠，才能开机作业，切实压缩无证作业空间。",
            "全面掌握电焊机、电焊⼯、电焊作业、涉焊企业、监管队伍等基础信息，实现“以码管机”、“以机管⼈”、“以智管焊”。",
          ],
        },
        {
          id: "6-3",
          // title: '加入焊工',
          picture: require("@/assets/img/product/product_dianhanHistory.jpg"),
          content: [
            "软件还能追踪用户使用电焊机的频率，为设备的维护和管理工作提供数据支持，确保设备的高效运转和长期稳定。",
            "软件系统还具备离线工作能力，无需依赖网络即可开机工作，提供了操作便利性和现场适应性。",
            "通过这些智能化特性，智能电焊机不仅提高了作业的安全性，也为用户带来了更加便捷和高效的工作体验。",
          ],
        },
      ],
    },
  ],
};

/** 应用场景 */
global.application = {
  title: "基于精准定位和实时通信的智能安全监控系统",
  titlePicture: require("@/assets/img/application/application.jpg"),
  applicationList: [
    {
      title: "建筑工地上的全方位人员安全定位",
      picture: require("@/assets/img/application/application_1.jpg"),
      content:
        "UWB精准定位技术在建筑工地应用前景广阔，它以高精度定位为核心，结合物联网、人工智能、三维建模等技术，以安全帽为载体，对建筑施工实现全方位无死角的监控，通过本系统能及时提醒工人将面临的安全风险，管理人员能及时掌握工人的各种安全行为及安全状况，防微杜渐及时采取安全措施从而保障工人的施工安全，为整个工地的安全施工保驾护航。",
    },
    {
      title: "消防领域人员安全定位",
      picture: require("@/assets/img/application/application_2.jpg"),
      content:
        "UWB精准定位技术应用于消防救援人员火场定位，可以使指挥中心根据实时位置信息判断消防员是否发生险情，同时对于发生火灾建筑的火情进行实时掌握，能够实现对消防人员进行合理安全引导，防止消防人员进入危险性较大的区域而发生危险。",
    },
    {
      title: "电力领域人员安全定位",
      picture: require("@/assets/img/application/application_3.jpg"),
      content:
        "UWB精准定位技术，在电厂这种信号屏蔽严重、作业环境经常变化、机器设备密集摆放容易形成信号遮蔽和折射的复杂环境下，仍能实现对现场人员和设备的全方位、无死角、可视化、立体式的监控，能够随时掌握现场人员的具体位置及安全情况。智能判别并及时警示现场作业人员可能存在的风险，把“被动的安全事故”转变到“智能发现安全问题、及时预防与阻止安全事故”。",
    },
    {
      title: "煤矿领域人员安全定位",
      picture: require("@/assets/img/application/application_4.jpg"),
      content:
        "UWB精准定位技术具有定位精度高、功耗低、覆盖距离远、成本适中、多径分辨能力强、穿透能力强、抗干扰能力强、隐蔽性好等优点，将其应用煤矿领域定位，可以很好克服复杂巷道空间内的障碍物阻挡，管理人员能够实时掌握井下人员及设备的准确位置和活动轨迹，同时对井下环境进行全方位过程管控，提高矿井企业事故预防能力，助力矿井安全生产。",
    },
    {
      title: "化工领域人员安全定位",
      picture: require("@/assets/img/application/application_5.jpg"),
      content:
        "化工厂的运营环境充满各种潜在危险，稍有不慎便可能引发事故。借助UWB精准定位技术，可以实时监控员工的位置和活动状态，一旦发现异常情况，立即采取应急措施，确保生产作业人员的安全，同时对化工生产区全方位监控，提高化工企业生产安全和效率。",
    },
    {
      title: "隧道管廊人员安全定位",
      picture: require("@/assets/img/application/application_6.jpg"),
      content:
        "隧道管廊施工场景具有密闭性强、形状狭长、信号遮蔽严重等特点，施工面临环境恶劣、安全管理难、危险系数高等问题。借助UWB精准定位技术，能够随时掌握现场人员的具体位置及安全情况，帮助管理方查找和改进薄弱环节，防范施工安全事故的发生。",
    },
    {
      title: "钢铁冶金人员安全定位",
      picture: require("@/assets/img/application/application_7.jpg"),
      content:
        "作钢铁冶炼从原料采购、焦化烧结、炼铁、炼钢、轧钢、到产出成品，具有冗长的生产工序、复杂的作业场景。在钢铁冶金领域，使用UWB精准定位技术可以精确监控作业人员的位置，及时发现异常情况并采取相应措施，减少意外事故发生。实现对生产现场资源跟踪、生产过程监控，为管理人员提供基于位置数据的分析，助其作出对应决策，提升企业效能。",
    },
  ],
};

/** 新闻资讯 */
global.news = {
  title: "权威媒体采访",
  titlePicture: require("@/assets/img/news/news.jpg"),
  titlePicture1: require("@/assets/img/news/news_1.jpg"),
  titlePicture2: require("@/assets/img/news/news_2.jpg"),
  titlePicture3: require("@/assets/img/news/news_3.jpg"),
  titlePicture4: require("@/assets/img/news/news_4.jpg"),
  titlePicture5: require("@/assets/img/news/news_5.jpg"),
  // 获得荣誉
  honorBackGround: require("@/assets/img/news/honorBackground.png"),
  honorTopBackGround: require("@/assets/img/news/honorTop.png"),
  honorList: [
    "国家高新技术企业",
    "杭州市雏鹰企业",
    "国家科技型中小企业",
    "2021年阿里巴巴诸神之战“5G+物联网”",
    "全球挑战赛长三角赛区决赛优胜奖",
    "2021年（第五届）博鳌企业峰会最佳技术应用",
    "商务部信用认证企业",
  ],
  honorPictureList: [
    require("@/assets/img/news/honor_1.jpg"),
    require("@/assets/img/news/honor_2.jpg"),
    require("@/assets/img/news/honor_3.jpg"),
    require("@/assets/img/news/honor_4.jpg"),
    require("@/assets/img/news/honor_5.jpg"),
    require("@/assets/img/news/honor_6.jpg"),
  ],
  // 新闻内容
  newsBackground: require("@/assets/img/news/newsBackground.png"),
  newsTopBackground: require("@/assets/img/news/newsTop.png"),
  newsTitle1: "“杭州格物智安科技”通过《信用中国》栏目评选",
  newsTitle2: "2023-05-23 09:42:00 大京网 ",
  newsContent: [
    "为进一步推进商业信用体系建设,促进企业诚实守信经营,面向企业普及诚信与品牌建设的意义,指导企业加强诚信品牌建设,提升整体竞争力,《信用中国》栏目组致力于大力宣传知名自主品牌,提高自主品牌影响力和认知度,以诚信为内涵,在全国范围内遴选出有行业代表性的民营企业作为扶持对象,在全国范围内打造中国榜样和品牌新势力。",
    "杭州格物智安科技有限公司成立于2018年,是国家高新技术企业、杭州市雏鹰企业。公司致力于将数字技术和工程作业安全管理的结合应用,企业以高实时、高穿透、高精度的通讯定位方案为基础,以智能安全帽为核心,结合传感器、摄像头、基站等载体,通过运用物联网、人工智能、虚拟现实、云计算、区块链等技术,构建一个针对工程作业的智能安全数字化监控系统。此系统可对工人、设备、现场情况实现高实时、无死角、高精度的安全监控。",
    "公司非常重视技术的研发,技术领先是其主要的核心竞争力。目前公司已经获得22项专利授权,其中包括5项发明专利,11项软件著作权。公司开发的产品具有成本合理、性能优越等强大的竞争优势,对工程作业智能安全监控特别是对建筑施工智能安全监控具有具有颠覆性的影响,让智能安全帽走进日常工程作业。",
    "《信用中国》栏目组委会鉴于杭州格物智安科技有限公司在智能安全数字化领域做出的突出贡献,以及助力企业发展,推动行业转型升级,带动地方经济发展及人才引进,特将其列入被扶持企业考察名单。",
    "随后,《信用中国》栏目组委对企业资质、管理和服务模式、企业诚信度等进行了深入细致的调查。",
    "在考察一行中,杭州格物智安科技有限公司的董事长蔡民强先生向大家介绍了企业现行的服务理念及未来的发展规划。",
    "一直以来,企业秉持“以新兴数字技术促进工程作业安全生产领域的管理革命,让工程作业更安全”的使命,致力实现国内国际领先的工程作业智能安全监控整体解决方案提供商的企业愿景,为工程作业安全生产的数字化管理革命做出不可替代的贡献。",
    "目前,企业已完成产品的研发、测试、在重要客户处完成试用,完善产品应用及商业模式,在部分客户或地区得到有效推广。同时,企业将实现快速复制,在1000个建筑工程项目以上得到应用,在建筑施工智能安全监控领域成为行业领先,同时,企业也将陆续把产品推向消防、电力、矿山、水泥厂、制造业加工厂等工程领域,让产品在更多的工程领域得到应用。",
    "未来,企业将以建筑施工智能安全监控系统为切入点,通过横向扩展开拓业务让工程作业智能安全监控系统在更多的工程作业领域得到应用从而实现市场倍增、价值倍增,通过纵向扩展开拓更多的建筑施工数字化及互联网业务,致力成为建筑数字科技赛道的头部企业。",
    "最终,杭州格物智安科技有限公司凭借良好企业信誉、独特的经营风格以及较强的市场开拓能力通过了栏目组委会最终考核,并列入扶持企业名单。随后还将邀请杭州格物智安科技有限公司的董事长蔡民强先生做客《信用中国》栏目,与知名主持人一起探讨企业发展中的经营管理之道。",
  ],
  // 专利授权
  patent:
    "在产品研发上，我们不断追求⼀流技术，取得了8项发明专利、17项实用新型专利、1项外观设计专利、11项软件著作权。",
  patentTopBackground: require("@/assets/img/news/patentTop.jpg"),
  patentPicture: [
    require("@/assets/img/news/patent1.png"),
    require("@/assets/img/news/patent2.png"),
  ],
};

/** 关于我们 */
global.aboutUs = {
  title: "用智能科技守护国民平安",
  picture: require("@/assets/img/aboutUs/aboutUs.jpg"),
  titlePicture: require("@/assets/img/aboutUs/aboutUsTitle.png"),
  titleContent: "我们以不断创新的产品，真诚的服务，欢迎广大新老客户的到来！",
  // 公司
  companyBackground: require("@/assets/img/aboutUs/companyBackground.jpg"),
  companyContent: [
    "杭州格物智安科技有限公司成立于2018年，为国家高新技术企业、杭州市雏鹰企业、杭州市创新型中小企业。公司拥有完善的自主研发体系，核心研发人员均为在世界500强企业工作多年的名校硕博。公司在精准定位、实时通信和AI算法等方面耕耘多年，取得了一系列的成果，对复杂环境下的人员安全监控不论是监控精度、覆盖度还是实时性等方面都处于行业领先地位。我们将紧跟时代潮流，为工程作业安全及产业的数字化贡献一份力量。",
  ],
  companyContentCulture: [
    "企业使命：用智能科技守护国民平安。",
    "企业愿景：成为共同富裕创业孵化平台。",
    "企业定位：在监控的精度、覆盖度、实时性方面能够适应各种复杂环境，处于行业领先地位。",
    "企业赛道：高精度定位、智能安全帽、AI技术、数字孪生、智能物联网系统。",
  ],
  companyPicture: require("@/assets/img/aboutUs/company.jpg"),
};



// WEBPACK FOOTER //
// ./src/assets/js/globalStatic.js